/** Annotation fields that change glyph metrics — auto-fit box after edits (even when textAutoHug is off). */
export const TEXT_TYPOGRAPHY_PATCH_KEYS = [
  'fontSize',
  'fontFamily',
  'fontStyle',
  'letterSpacing',
  'lineHeight',
];

export const patchTouchesTextTypography = (patch) =>
  Boolean(
    patch &&
      typeof patch === 'object' &&
      TEXT_TYPOGRAPHY_PATCH_KEYS.some((key) =>
        Object.prototype.hasOwnProperty.call(patch, key),
      ),
  );
